export const TEAM_CREATION_DATA_REQUEST = "TEAM_CREATION_DATA_REQUEST";
export const TEAM_CREATION_DATA_RECEIVE = "TEAM_CREATION_DATA_RECEIVE";
export const TEAM_CREATION_DATA_FAILURE = "TEAM_CREATION_DATA_FAILURE";
export const RESET_TEAM_CREATION_DATA = "RESET_TEAM_CREATION_DATA";
